// extracted by mini-css-extract-plugin
export default {"nav":"PageNav_nav__WRVB6","ctaLink":"PageNav_ctaLink__HaspI"};